export default __webpack_public_path__ + "static/media/giraffe-yellow.2702ba79.svg";